// Google tag (GA4 + Google Ads) — env-driven so it stays dormant until whoever
// runs the campaigns provides the IDs. Leave the env vars blank to disable.
//
//   REACT_APP_GA4_ID                  e.g. G-XXXXXXXXXX   (Google Analytics 4)
//   REACT_APP_GADS_ID                 e.g. AW-XXXXXXXXX   (Google Ads)
//   REACT_APP_GADS_CONVERSION_LABEL   e.g. abCdEfGhIj     (the conversion's label)

const GA4_ID = process.env.REACT_APP_GA4_ID;
const GADS_ID = process.env.REACT_APP_GADS_ID;
const GADS_LABEL = process.env.REACT_APP_GADS_CONVERSION_LABEL;

export const analyticsEnabled = Boolean(GA4_ID || GADS_ID);

let initialised = false;

export function initAnalytics() {
  if (initialised || !analyticsEnabled || typeof window === "undefined") return;
  initialised = true;

  const primaryId = GA4_ID || GADS_ID;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${primaryId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  if (GA4_ID) gtag("config", GA4_ID);
  if (GADS_ID) gtag("config", GADS_ID);
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}

// Fires a Google Ads conversion (needs REACT_APP_GADS_ID + REACT_APP_GADS_CONVERSION_LABEL).
export function trackConversion(extra = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  if (!GADS_ID || !GADS_LABEL) return;
  window.gtag("event", "conversion", {
    send_to: `${GADS_ID}/${GADS_LABEL}`,
    ...extra,
  });
}
